import React from 'react';
import { Exhibitor } from './types';
import { ExpoCard } from './ExpoCard';

interface ExpoGridProps {
  exhibitors: Exhibitor[];
  viewMode: 'grid' | 'list';
  onExhibitorClick: (exhibitor: Exhibitor) => void;
  primaryColor?: string;
}

export const ExpoGrid: React.FC<ExpoGridProps> = ({
  exhibitors,
  viewMode,
  onExhibitorClick,
  primaryColor = "#2563eb"
}) => {
  if (exhibitors.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No exhibitors found matching your criteria.</p>
      </div>
    );
  }

  // Sort exhibitors by position only
  const sortedExhibitors = [...exhibitors].sort((a, b) => a.position - b.position);

  if (viewMode === 'list') {
    return (
      <div className="space-y-4">
        {sortedExhibitors.map(exhibitor => (
          <ExpoCard
            key={exhibitor.id}
            exhibitor={exhibitor}
            onClick={() => onExhibitorClick(exhibitor)}
            viewMode="list"
            primaryColor={primaryColor}
          />
        ))}
      </div>
    );
  }

  // Grid view
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-fr">
      {sortedExhibitors.map(exhibitor => (
        <ExpoCard
          key={exhibitor.id}
          exhibitor={exhibitor}
          onClick={() => onExhibitorClick(exhibitor)}
          viewMode="grid"
          primaryColor={primaryColor}
        />
      ))}
    </div>
  );
};